import { Redirect, Route } from 'react-router';
import Links from '../data/Links';
import React from 'react';

export default function ProtectedRoute(props) {
	if (props.auth) return <Route path={props.path} exact component={props.component} />;
	else return <Redirect from={props.path} to={Links.LOGIN} exact />;
}
